import React from 'react';

import { WelcomeSection, NavigationButtons, ProfileFooter } from './components';
import {
  ProfileNavigationProvider,
  useProfileNavigation,
} from './contexts/ProfileNavigationContext';
import {
  HomePage,
  ProfilePage,
  YourPlansPage,
  BillingPage,
  ResourcesPage,
} from './pages';

const ProfileContent = () => {
  const { activePage } = useProfileNavigation();

  const renderActivePage = () => {
    switch (activePage) {
      case 'Home':
        return <HomePage />;
      case 'Profile':
        return <ProfilePage />;
      case 'Your plans':
        return <YourPlansPage />;
      case 'Billing':
        return <BillingPage />;
      case 'Resources':
        return <ResourcesPage />;
      default:
        return <HomePage />;
    }
  };

  return (
    <div className="profile flex flex-col gap-8 mt-7 max-md:w-full">
      <WelcomeSection />
      <NavigationButtons />
      {renderActivePage()}
      <ProfileFooter />
    </div>
  );
};

export const Profile = () => {
  return (
    <ProfileNavigationProvider>
      <ProfileContent />
    </ProfileNavigationProvider>
  );
};
